export function parseTimestampMs(raw: string | undefined): number | null {
  if (typeof raw !== 'string' || raw.trim() === '') return null
  const ms = Date.parse(raw)

  return Number.isFinite(ms) ? ms : null
}

/** True when book `planbookUpdatedAt` is strictly newer than the spread-side timestamp (guides / view / snap each use their own spread `updatedAt`). */
export function shouldPreferBookSetting(
  bookUpdatedAt: string | undefined,
  spreadUpdatedAt: string | undefined
): boolean {
  const bookMs = parseTimestampMs(bookUpdatedAt)

  if (bookMs == null) return false

  const spreadMs = parseTimestampMs(spreadUpdatedAt)

  if (spreadMs == null) return true
  return bookMs > spreadMs
}

export function getLatestTimestamp(...timestamps: Array<string | undefined>): string | undefined {
  let latestTimestamp: string | undefined
  let latestMs: number | null = null

  for (const timestamp of timestamps) {
    const ms = parseTimestampMs(timestamp)

    if (ms == null) continue
    if (latestMs != null && ms <= latestMs) continue

    latestMs = ms
    latestTimestamp = timestamp
  }

  return latestTimestamp
}
